import React from 'react';
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import {DialogContent} from "@mui/material";
import SensorWithPlacements from "./SensorWithPlacements";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";

const SensorDialog = ({sensor, onClose}) => {
    return (
        <Dialog
            open={true}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullScreen={true}>

            <DialogTitle id="alert-dialog-title">
                {sensor?.boardId}
            </DialogTitle>
            <DialogContent>
                <SensorWithPlacements
                    sensor={sensor}
                    placements={sensor?.placements}
                    isTest={true}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default SensorDialog;